import { type TransactionActivity, type TransactionActivityList } from '@kalos/kalos-rpc';

import { useTransactionActivityBatchGet } from '../../../../hooks/react-query/useTransactionActivityQuery';
import { isRejectionActivity } from '../../../TransactionUser/components/receiptCard.utils';

const selectLatestRejection = (data: TransactionActivityList | undefined) =>
  (data?.results ?? []).reduce<TransactionActivity | undefined>(
    (latest, activity) =>
      isRejectionActivity(activity.description) && (!latest || activity.id > latest.id)
        ? activity
        : latest,
    undefined,
  );

const TransactionRejectReason = ({ transactionId }: { transactionId: number }) => {
  // BatchGet returns 25 rows per page, so the last row of an unfiltered first page isn't the
  // newest on a long history. Ask only for rows mentioning a rejection and take the highest id.
  const rejectionQuery = useTransactionActivityBatchGet({
    filters: {
      transactionId,
      description: '%rejected%',
    },
    select: selectLatestRejection,
  });

  if (rejectionQuery.isPending) return <div>Loading...</div>;

  if (rejectionQuery.data) {
    return (
      <div>
        <h3>Reason:</h3>
        <p>{rejectionQuery.data.description}</p>
      </div>
    );
  }

  return <div>Rejected</div>;
};

export default TransactionRejectReason;
